var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPackageOneYear(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 800",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2,.cls-3{fill:#68a8de;}.cls-2{stroke:#009de0;opacity:0.3;}.cls-4{mix-blend-mode:multiply;}.cls-5{fill:#4570b4;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Tavola disegno 3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Livello_1",
    "data-name": "Livello 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: -4.43,
    y: -10,
    width: 808.85,
    height: 820
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M219.05,170.35,247.9-10H581L451.1,810H253.91l101-639.65Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M144.52,298.28l36.39,203.44H130.2l-6.27-40.87H60.4L41.61,501.72H-10L95.89,298.28ZM110.06,365.1q-.44-8.06-.74-14h-1.2q-1.49,6.27-4.47,14.91a152.17,152.17,0,0,1-6.56,16.11L76.8,425.36h42.06L112,381.8A147.18,147.18,0,0,1,110.06,365.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M233.4,298.28h43.26l34.6,81.14q5.07,11.93,9.84,23.26t7.46,18.8h.9q.59-6.87,1.79-15.07t2.08-14.17l14.92-94H392.4L360.18,501.72h-43l-29.53-68.91q-8.35-19.38-14.46-34.6t-8.51-22.37h-.89q-.6,6.56-1.79,17.15t-2.68,20.14l-14,88.59H201.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M429.08,298.28h43.26l34.6,81.14q5.07,11.93,9.84,23.26t7.46,18.8h.89q.6-6.87,1.79-15.07T529,392.24l14.92-94h44.14L555.86,501.72h-43l-29.53-68.91q-8.36-19.38-14.47-34.6t-8.5-22.37h-.89q-.6,6.56-1.79,17.15T455,413.13l-14,88.59H396.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M655.48,500.53a93.45,93.45,0,0,1-51.3-52.06A99.76,99.76,0,0,1,597,410.74a142.69,142.69,0,0,1,6.71-43.11,110,110,0,0,1,20.88-38.18,106.54,106.54,0,0,1,35.8-27.29q21.62-10.44,51.45-10.44,22.67,0,40.72,7.61a90.78,90.78,0,0,1,50.56,51.9A105.47,105.47,0,0,1,810,389.56q0,27.45-8.5,49.52a107.07,107.07,0,0,1-23.72,37.43,103.32,103.32,0,0,1-36.09,23.57q-20.88,8.21-45.94,8.2Q673.69,508.28,655.48,500.53ZM721,456.08a51.08,51.08,0,0,0,19.24-13.42,64.61,64.61,0,0,0,12.68-22.23q4.62-13.28,4.62-30.87a60,60,0,0,0-3.13-19.39,44.7,44.7,0,0,0-9.25-16,45.75,45.75,0,0,0-14.91-10.74,48.76,48.76,0,0,0-20.44-4q-16.11,0-27.59,5.81a51.24,51.24,0,0,0-18.64,15.66A67.8,67.8,0,0,0,653,383.59a102.23,102.23,0,0,0-3.43,26.55,60.26,60.26,0,0,0,3.28,20.29,46.68,46.68,0,0,0,9.39,16A42.55,42.55,0,0,0,677,456.83a48.62,48.62,0,0,0,19.39,3.72A65.75,65.75,0,0,0,721,456.08Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackageOneYear);
export default __webpack_public_path__ + "static/media/packageOneYear.4da2b7a3eb7e958103547126dbb9dc74.svg";
export { ForwardRef as ReactComponent };